import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  name: {
    id: "F56hOz",
    defaultMessage: "Name",
    description: "sale name",
  },
  starts: {
    id: "iBSq6l",
    defaultMessage: "Starts",
    description: "sale start date",
  },
  ends: {
    id: "giF5UV",
    defaultMessage: "Ends",
    description: "sale end date",
  },
  type: {
    id: "z/2AZY",
    defaultMessage: "Discount type",
  },
});

export const messages = defineMessages({
  empty: {
    id: "IYuKD6",
    defaultMessage: "No discounts found",
  },
});
